
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import NoData from '../NoData/NoData.vue';

import {
getTrades,
closeTrade,
confirmReceipt,
createPay,
confirmCloseTrade,
aftersalesApply,
commitAftersalesApply
} from '../../api';
import querystring from 'vux/src/tools/querystring/index.js'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
components: {
MHeader,
Scroller,
LoadMore,
NoData,
Popup,
Group,
Radio,
XTextarea,
Confirm,
ViewBox,
Actionsheet,
XDialog,
Tab,
TabItem
},
directives: {
TransferDom
},
data() {
return {
statusList: [
{
status: '',
text: '全部订单'
},{
status: 'unpaid',
text: '待付款'
},{
status: 'paid',
text: '待发货'
},{
status: 'shipped',
text: '已发货'
}
],
h: "",
page_size: 10,
payMethodList: {
wxpay: '微信支付',
alipay: '支付宝付款'
},

status: "",
page_no: 1,
listParams:{
status: ''
},
list: [],
isTrue: false,
isLoadMore: false,
showLoad: false,
titleName: "",
orderItem: "",
fromPathName: "",
show1: false,
show2: false,
radio001: [],
remIndex: "",
tid: "",
payingOrderId: "",
show5: false,
daifuImg: "",
showPayList: false,
cancel_reason: "", // 取消订单 原因编号
other_reason: "", // 其他原因 内容
titleName2: "",
listData: null 
}
},
methods: {
totalCount(order) {
let count = 0
_.forEach(order.products, (product) => {
count += product.quantity
})
return count
},
tixing() {
setTimeout(() => {
this.$store.commit('hideIsLoading');
this.$store.commit('updateToast', {
show: true,
text: '已提醒卖家发货，请您耐心等待。'
});
}, 1500);
},
refund(item, index, index2) {
this.listIndex = index; 
this.orderIndex = index2; 
this.orderItem = item;
if (item.aftersales_status == null) {
this.orderItem = item;
aftersalesApply(item.tid, item.oid).then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
this.titleName2 = res.data.title || '申请售后';
let list = res.data.reason;
this.radio001 = res.data.reason;
this.show1 = true;
})
} else { // 跳转到 售后详情
console.log(this.list);
this.$router.push({
name: 'RefundDetail',
params: {
id: this.list[index].aftersale.aftersales_bn
}
})
};
},
cancelBtn2() {
if (this.titleName2 == '取消订单') {
let data = {
other_reason: this.other_reason,
cancel_reason: this.cancel_reason,
tid: this.tid
};
if (this.cancel_reason != 'other') {
delete data.other_reason
};
let test = querystring.stringify(data);
confirmCloseTrade(test).then(res => {
if (res.data.error_code) {
alert(JSON.stringify(res.data.msg));
console.error(res);
return;
};
this.$store.commit('updateToast', {
show: true,
text: '成功取消订单'
});
this.show1 = false;
this.list.splice(this.remIndex, 1);
this.cancel_reason = "";
this.other_reason = "";
this.$nextTick(() => {
this.$refs.scrollerBottom.reset();
});
});
} else {
if (this.cancel_reason == 'other') {
var text = this.other_reason;
} else {
var text = this.radio001[this.cancel_reason - 1];
};

commitAftersalesApply({
tid: this.orderItem.tid,
oid: this.orderItem.oid,
text: text
}).then(res => {
if (res.data.error_code) {
this.$store.commit('updateToast', {
show: true,
text: res.data.msg
});
return;
}
this.$store.commit('updateToast', {
show: true,
text: res.data.msg || '提交申请成功,请耐心等待。'
});
this.list[this.listIndex].order[this.orderIndex].aftersales_status = true;
this.list[this.listIndex].aftersale = {
aftersales_bn: res.data.aftersales_bn
};
this.show1 = false;
this.cancel_reason = "";
this.other_reason = "";
});
}

},
scrollBtm() {
if (this.isTrue) {
this.isTrue = false;
this.page_no++;
this.getTrades();
};
},
canceOrderOpt(e) {
this.cancel_reason = e == '其他原因' ? 'other' : (this.radio001).indexOf(e) + 1;
console.log(this.cancel_reason);
},

cancaleBtn(id, text) {
if (!id) {
this.$store.commit('updateToast', {
show: true,
text: this.titleName2 == '取消订单' ? '请选择取消订单的原因' : '请选择申请退款的原因'
});
return;
};
if (id == 'other' && !text) {
this.$store.commit('updateToast', {
show: true,
text: '请填写其他原因内容'
});
return;
};
this.show2 = true;
},
toPay(payMethod) {
var that = this
if (payMethod == 'alipay') {
location.href = '/#/pay?payMethod=alipay&payingOrderId='+this.payingOrderId
} else if (navigator.userAgent.match('MicroMessenger')) {
Api.wxPay(this.payingOrderId)
.then(res => {
WeixinJSBridge.invoke("getBrandWCPayRequest", res.data, function (res) {
if (res.err_msg == 'get_brand_wcpay_request:ok') {
that.$store.commit('updateToast', {
show: true,
text: '付款成功'
});
that.loadOrder()
} else {
that.$store.commit('updateToast', {
show: true,
text: '付款失败请重新支付'
});
}
});
})
} else {
location.href = '/#/pay?payMethod=wxh5pay&payingOrderId='+this.payingOrderId
}
},
paySelect(orderId, index) {
this.payingOrderId = orderId
this.showPayList = true
},
confirmReceived(orderId, index) {
var that = this
Api.orderReceived(orderId)
.then(res=> {
that.$store.commit('updateToast', {
show: true,
text: '确认成功'
});
that.loadList()
})
},
back() {
if (!this.show1) {
switch (this.fromPathName) {
case "payStatus":
this.$router.go(-3);
break;
default:
this.$router.replace({
name: 'userCenter'
});
break;
};
} else {
this.show1 = false;
};

},
getTrades() {
var test = querystring.stringify({
page_size: this.page_size,
status: this.status,
page_no: this.page_no
});
getTrades(test).then(res => {
if (res.data.error_code) {
alert(res.data.msg);

return;
};
if (res.data.data.count == 0 && this.page_no != 1) {
this.isLoadMore = true;
this.isTrue = this.showLoad = false;
return;
};
if (res.data.data.count == 0 || !res.data.data.tradeList) {
this.isTrue = this.showLoad = this.isLoadMore = false;
return;
};
let list = res.data.data.tradeList;

this.list = this.list.concat(list);
if (this.page_no == 1) {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({
top: 0
});
this.isTrue = true;
});
} else {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset();
this.isTrue = this.showLoad = true;
});
};

});
},
isFoot(val) {
switch (val) {
case "WAIT_BUYER_PAY":
return true;
break;
case "WAIT_BUYER_CONFIRM_GOODS":
return true;
break;
case "WAIT_SELLER_SEND_GOODS":
return true;
break;
case "TRADE_CLOSED_BY_SYSTEM":
return false;
break;
case "TRADE_FINISHED":
return false;
break;
default:
}
},
confirmReceipt(tid, index) {
confirmReceipt(`tid=${tid}`).then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
this.$store.commit('updateToast', {
show: true,
text: '确认收货完成'
});
this.list.splice(index, 1);
this.$nextTick(() => {
this.$refs.scrollerBottom.reset();
});
})
},
closeTrade(tid, index) {
this.tid = tid;
this.remIndex = index;
closeTrade(`tid=${tid}`).then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
this.titleName2 = '取消订单';
this.show1 = true;
this.radio001 = [];
for (let item in res.data.reason.user) {
this.radio001.push(res.data.reason.user[item]);
}

})
},
selectLogistics(tid) {
this.$router.push({
name: 'courierInfo',
params: {
tid: tid
}
})
},
toDetail(order) {
this.$router.push({
name: 'orderDetail',
params: {
tid: order._id
}
});
},
ablaengen(val) { // 截取订单 商品长度
return val.length > 2 ? val.slice(0, 3) : val;
},
loadList() {
Api.getOrderList(this.listParams)
.then((res) => {
this.list = res.data
})
},
changeTab(item) {
console.log(item)
this.listParams.status = item.status
this.loadList()
},
cancelOrder(orderId) {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '是否取消订单',
onConfirm() {
Api.orderCancel(orderId)
.then(res=> {
that.$store.commit('updateToast', {
show: true,
text: '取消订单成功'
});
that.loadList()
})
}
})
},
refundOrder(orderId) {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '是否确认申请退款',
onConfirm() {
Api.refundOrder(orderId)
.then(res=> {
that.$store.commit('updateToast', {
show: true,
text: '提交退款申请成功, 等待确认'
});
that.loadList()
})
}
})
},
expressInfo(orderId) {
this.$router.push({
name: 'courierInfo',
params: {
tid: orderId
}
})
}
},
created() {
this.h = document.documentElement.clientHeight - 0.88 * (document.documentElement.clientWidth / 7.5) + 'px';
if(this.$route.params.pathName != 'all'){
this.listParams.status = this.$route.params.pathName
}
this.loadList()
if (this.$route.query.payingOrderId) {
Api.getOrder(this.$route.query.payingOrderId)
.then((resp) => {
console.log(resp)
if (resp && resp.data && resp.data.status === 'unpaid') {
this.paySelect(this.$route.query.payingOrderId)
}
})
}
},
computed: {},
filters: {
topText(val) {
switch (val) {
case "WAIT_BUYER_PAY":
return "等待付款";
break;
case "WAIT_BUYER_CONFIRM_GOODS":
return "卖家已发货";
break;
case "WAIT_SELLER_SEND_GOODS":
return "买家已支付";
break;
case "TRADE_CLOSED_BY_SYSTEM":
return "交易关闭";
break;
case "TRADE_FINISHED":
return "交易完成";
break;
default:
}
}
},
beforeRouteEnter: (to, from, next) => {
var pathName = from.name;
console.log(pathName != 'orderDetail');
if (pathName == 'orderDetail' || pathName == 'RefundDetail') {
next();
} else {
next(vm => {
vm.page_no = 1;
vm.list = [];
vm.isLoadMore = false;
vm.fromPathName = pathName;
vm.cancel_reason = vm.other_reason = "";
switch (vm.$route.path) {
case '/orderList/all':
vm.titleName = '全部订单'
vm.status = "All";
break;
case '/orderList/unpaid':
vm.titleName = '待付款'
vm.status = "WAIT_BUYER_PAY";
break;
case '/orderList/paid':
vm.titleName = '待发货'
vm.status = "WAIT_SELLER_SEND_GOODS";
break;
case '/orderList/shipped':
vm.titleName = '待收货'
vm.status = "WAIT_BUYER_CONFIRM_GOODS";
break;
case '/orderList/received':
vm.titleName = '已完成'
vm.status = "sale_after";
break;
default:
vm.titleName = '全部订单'
vm.status = "All";
break;
};

});
};
},
beforeRouteUpdate(to, from, next) {
this.show5 = this.isLoadMore = false;
this.page_no = 1;
this.list = [];
this.fromPathName = from.name;
this.cancel_reason = this.other_reason = this.daifuImg = "";
switch (to.path) {
case '/orderList/all':
this.titleName = '全部订单'
this.status = "All";
break;
case '/orderList/unpaid':
this.titleName = '待付款'
this.status = "WAIT_BUYER_PAY";
break;
case '/orderList/paid':
this.titleName = '待发货'
this.status = "WAIT_SELLER_SEND_GOODS";
break;
case '/orderList/shipped':
this.titleName = '待收货'
this.status = "WAIT_BUYER_CONFIRM_GOODS";
break;
case '/orderList/received':
this.titleName = '已完成'
this.status = "sale_after";
break;
default:
this.titleName = '全部订单'
this.status = "All";
break;
};

next();
}
}



// WEBPACK FOOTER //
// ./src/components/OrderList/all.vue